/**
 * @fileoverview POST handler for the "/reporting/:app_group_id/metrics/query" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postReportingAppGroupIdMetricsQueryCacheKeys } from "./constants";
import type { PostReportingAppGroupIdMetricsQueryProps, PostReportingAppGroupIdMetricsQueryResult } from "./types";

export const postReportingAppGroupIdMetricsQuery = reactQueryMutationAdapter(
  postReportingAppGroupIdMetricsQueryCacheKeys,
  (props: PostReportingAppGroupIdMetricsQueryProps): Promise<PostReportingAppGroupIdMetricsQueryResult> => {
    // manipulate props here as needed reportingQuery

    return fetch(`/reporting/${props.appGroupId}/metrics/query`, "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
